export const setSlackValue = (state, data) => {
	state.setSlackValue = data.is_slack;
}